import { __decorate } from "tslib";
import { injectable } from "inversify";
import { LocaleSource } from "./LocaleSource";
import { LocaleObject } from "../../locale/Locale";
let NavigatorLocaleSource = class NavigatorLocaleSource extends LocaleSource {
    getLocales() {
        const locales = [];
        for (const l of navigator.languages) {
            const parsed = LocaleObject.tryParse(l);
            if (!parsed)
                continue;
            locales.push(parsed);
        }
        return Promise.resolve(locales);
    }
};
NavigatorLocaleSource = __decorate([
    injectable()
], NavigatorLocaleSource);
export { NavigatorLocaleSource };
//# sourceMappingURL=NavigatorLocaleSource.js.map